export function ConvertHourlyDataForBarChart(hourlyConsumption) {
    return {
        type: 'bar',
        showBackground: true,
        itemStyle: { color: '#ab0207' },
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)'
        },
        data: Array.from(hourlyConsumption, x => x.groupConsumption)
    };
}

export function GetCategoriesFromHourlyData(hourlyConsumption) {
    return Array.from(hourlyConsumption, x => new Date(x.toDate).toLocaleTimeString());
}

// export function TransformVcbConsumptionToStackedBarChart(vCBConsumptionnTrendCollection, isStackedChartRequired = true) {
//     if (!vCBConsumptionnTrendCollection || vCBConsumptionnTrendCollection.length === 0) {
//         return null;
//     }

//     const chartDataMapping = {};
//     const response = {
//         series: [],
//         categories: []
//     };

//     // Extract unique dates for categories
//     const uniqueDates = new Set();
//     vCBConsumptionnTrendCollection.forEach(entry => {
//         const fromDate = new Date(entry.fromDate).toLocaleDateString();
//         const toDate = new Date(entry.toDate).toLocaleDateString();
//         uniqueDates.add(fromDate);
//         uniqueDates.add(toDate);
//     });

//     // Convert the set to a sorted array
//     const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));
//     response.categories = sortedDates;
//     // response.categories.pop()

//     vCBConsumptionnTrendCollection.forEach(entry => {
//         const key = `${entry.groupID}-${entry.meterID}`;
//         if (!chartDataMapping[key]) {
//             chartDataMapping[key] = {
//                 GroupID: entry.groupID,
//                 MeterID: entry.meterID,
//                 GroupName: entry.groupName,
//                 MeterName: entry.meterName,
//                 type: "bar",
//                 stack: isStackedChartRequired ? entry.groupName : null,  // Stack by group name if stacking is required
//                 name: entry.meterName,
//                 data: Array(sortedDates.length).fill(0)  // Initialize data array
//             };
//         }

//         // Find the index of the current fromDate and toDate in the categories array
//         const fromIndex = sortedDates.indexOf(new Date(entry.fromDate).toLocaleDateString());
//         const toIndex = sortedDates.indexOf(new Date(entry.toDate).toLocaleDateString());

//         // Distribute the kWh total across the date range
//         for (let i = fromIndex; i <= toIndex; i++) {
//             chartDataMapping[key].data[i] += entry.kwhTotal;
//         }
//     });

//     response.series = Object.values(chartDataMapping);
//     console.log(response.series[0].data)
//     const formattedData = data.map(num => parseFloat(num.toFixed(2)));
//     response.series[0].data.shift();
//     console.log(response.series[0].data)
//     console.log(response.categories)
//     response.categories.pop()
//     console.log(response.categories)


//     return response;
// }

export function TransformVcbConsumptionToStackedBarChart(
    vCBConsumptionnTrendCollection,
    isStackedChartRequired = true
  ) {
    if (!vCBConsumptionnTrendCollection || vCBConsumptionnTrendCollection.length === 0) {
      return null;
    }
  
    const chartDataMapping = {};
    const response = {
      series: [],
      categories: []
    };
  
    // Extract unique dates for categories
    const uniqueDates = new Set();
    vCBConsumptionnTrendCollection.forEach(entry => {
      uniqueDates.add(new Date(entry.fromDate).toLocaleDateString());
    });
  
    // Convert the set to a sorted array
    const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));
    response.categories = sortedDates;
  
    vCBConsumptionnTrendCollection.forEach(entry => {
      const key = `${entry.groupID}-${entry.meterID}`;
      
      if (!chartDataMapping[key]) {
        chartDataMapping[key] = {
          GroupID: entry.groupID,
          MeterID: entry.meterID,
          GroupName: entry.groupName,
          MeterName: entry.meterName,
          type: "bar",
          stack: isStackedChartRequired ? entry.groupName : null, // Stack by group name if stacking is required
          name: entry.meterName,
          data: Array(sortedDates.length).fill(0) // Initialize data array
        };
      }
  
      // Find the index of the current fromDate in the categories array
      const fromIndex = sortedDates.indexOf(new Date(entry.fromDate).toLocaleDateString());
      
      // Assign the kwhTotal directly to that date index without summing
      if (fromIndex !== -1) {
        chartDataMapping[key].data[fromIndex] = entry.kwhTotal;
      }
    });
  
    // Convert the object values to an array
    response.series = Object.values(chartDataMapping);
  
    return response;
  }
//  export function TransformVcbConsumptionToStackedBarChart(
//   vCBConsumptionnTrendCollection,
//   isStackedChartRequired = true
// ) {
//   if (!vCBConsumptionnTrendCollection || vCBConsumptionnTrendCollection.length === 0) {
//     return null;
//   }

//   const chartDataMapping = {};
//   const response = {
//     series: [],
//     categories: []
//   };

//   // Extract unique dates for categories
//   const uniqueDates = new Set();
//   vCBConsumptionnTrendCollection.forEach(entry => {
//     const fromDate = new Date(entry.fromDate).toLocaleDateString();
//     const toDate = new Date(entry.toDate).toLocaleDateString();
//     uniqueDates.add(fromDate);
//     uniqueDates.add(toDate);
//   });

//   // Convert the set to a sorted array
//   const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));
//   response.categories = sortedDates;

//   vCBConsumptionnTrendCollection.forEach(entry => {
//     const key = `${entry.groupID}-${entry.meterID}`;
//     if (!chartDataMapping[key]) {
//       chartDataMapping[key] = {
//         GroupID: entry.groupID,
//         MeterID: entry.meterID,
//         GroupName: entry.groupName,
//         MeterName: entry.meterName,
//         type: "bar",
//         stack: isStackedChartRequired ? entry.groupName : null, // Stack by group name if stacking is required
//         name: entry.meterName,
//         data: Array(sortedDates.length).fill(0) // Initialize data array
//       };
//     }

//     // Find the index of the current fromDate and toDate in the categories array
//     const fromIndex = sortedDates.indexOf(new Date(entry.fromDate).toLocaleDateString());
//     const toIndex = sortedDates.indexOf(new Date(entry.toDate).toLocaleDateString());

//     // Distribute the kWh total across the date range
//     for (let i = fromIndex; i <= toIndex; i++) {
//       chartDataMapping[key].data[i] += entry.kwhTotal;
//     }
//   });

//   // Convert the object values to an array and ensure all values have only two decimal places
//   response.series = Object.values(chartDataMapping).map(series => ({
//     ...series,
//     data: series.data.map(num => parseFloat(num.toFixed(3))) // Ensure 2 decimal places
//   }));

//   console.log(response.series[0].data);
//   response.series[0].data.shift();
//   console.log(response.series[0].data);
//   console.log(response.categories);
//   response.categories.pop();
//   console.log(response.categories);

//   return response;
// }



export function GetVcbConsumptionChartKey(vCBConsumptionTrend) {
    return vCBConsumptionTrend['groupID'] + ':' + vCBConsumptionTrend['meterID'];
}
 
// export function TransformWeeklyConsumptionToStackedBarChart(weeklyConsumptionDataCollection) {
//     if (weeklyConsumptionDataCollection == null || weeklyConsumptionDataCollection.length == 0) {
//         return null; 
//     }

//     var dates = Object.keys(weeklyConsumptionDataCollection);
//     var chartDataMapping = {};

//     var response = {
//         series: [],
//         categories: [] 

//     }

//     const startDate = dates[0];
//     // [
//     //     {
//     //       groupName: 'TNEB+Solar',
//     //       groupID: 2,
//     //       subGroupName: '33kV TNEB',
//     //       subGroupConsumption: 10,
//     //       subGroupID: 2,
//     //       fromDate: '2024-08-21T10:56:04',
//     //       toDate: '2024-08-22T10:56:04'
//     //     },
//     //     {
//     //       groupName: 'TNEB+Solar',
//     //       groupID: 2,
//     //       subGroupName: 'Solar',
//     //       subGroupConsumption: 5,
//     //       subGroupID: 3,
//     //       fromDate: '2024-08-21T10:56:04',
//     //       toDate: '2024-08-22T10:56:04'
//     //     }
//     //   ]
//     console.log(dates)
//     console.log(weeklyConsumptionDataCollection)
//     console.log(weeklyConsumptionDataCollection[0])
 
//     dates.map(date => {
//         weeklyConsumptionDataCollection[date].map(vCBConsumptionTrend => {
//             const key = GetWeeklyConsumptionChartKey(vCBConsumptionTrend);
//             if (chartDataMapping[key] == null) { 
//                 chartDataMapping[key] = {
//                     GroupID: vCBConsumptionTrend['groupID'],
//                     SubGroupID: vCBConsumptionTrend['subGroupID'],
//                     GroupName: vCBConsumptionTrend['groupName'],
//                     SubGroupName: vCBConsumptionTrend['subGroupName'],
//                     fromDateTime: vCBConsumptionTrend['fromDate'],
//                     toDateTime: vCBConsumptionTrend['toDate'],
//                     type: "bar",
//                     stack: key,
//                     name: vCBConsumptionTrend['subGroupName'],
//                     data: Array(Math.abs(Date.parse(date) - Date.parse(startDate)) / (1000 * 3600 * 24)).fill("-")
//                 }
//             }

//             chartDataMapping[key].data.push(vCBConsumptionTrend['subGroupConsumption']);
//         });
//     })

//     response.series = Object.values(chartDataMapping);
//     response.categories = Array.from(dates, x => new Date(x).toLocaleDateString());

//     console.log(response)
//     return response;
// }

export function TransformWeeklyConsumptionToStackedBarChart(weeklyConsumptionDataCollection) {
    if (!weeklyConsumptionDataCollection || weeklyConsumptionDataCollection.length === 0) {
        return null;
    }

    const chartDataMapping = {};
    const response = {
        series: [],
        categories: []
    };

    // Extract unique dates for categories
    const uniqueDates = new Set();
    weeklyConsumptionDataCollection.forEach(entry => {
        const fromDate = new Date(entry.fromDate).toLocaleDateString();
        const toDate = new Date(entry.toDate).toLocaleDateString();
        uniqueDates.add(fromDate);
        uniqueDates.add(toDate);
    });

    const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));
    response.categories = sortedDates;

    weeklyConsumptionDataCollection.forEach(entry => {
        const key = `${entry.groupID}-${entry.subGroupID}`;
        if (!chartDataMapping[key]) {
            chartDataMapping[key] = {
                GroupID: entry.groupID,
                SubGroupID: entry.subGroupID,
                GroupName: entry.groupName,
                SubGroupName: entry.subGroupName,
                type: "bar",
                stack: entry.groupName,
                name: entry.subGroupName,
                data: Array(sortedDates.length).fill(0)
            };
        }

        // Calculate the index for fromDate and toDate in the sortedDates array
        const fromIndex = sortedDates.indexOf(new Date(entry.fromDate).toLocaleDateString());
        const toIndex = sortedDates.indexOf(new Date(entry.toDate).toLocaleDateString());

        // Fill data array with consumption values for the range between fromDate and toDate
        for (let i = fromIndex; i <= toIndex; i++) {
            chartDataMapping[key].data[i] += entry.subGroupConsumption;
        }
    });

    response.series = Object.values(chartDataMapping);

    console.log(response);
    return response;
}


export function GetWeeklyConsumptionChartKey(vCBConsumptionTrend) {
    return vCBConsumptionTrend['groupID'] + ':' + vCBConsumptionTrend['subGroupID'];
}

export function TransformHTDataToDataTable(htData) {
    if (htData == null || htData.length == 0) {
        return null;
    }

    var response = [];

    htData.map(htDataItem => {
        response.push({
            meterName: htDataItem['meterName'],
            kwt: htDataItem['kwt'],
            vllAvg: htDataItem['v_LLAvg'],
            status: htDataItem['v_LLAvg'] > 0 ? 'Active' : 'Inactive',
        });
    });

    return response;
}

// export function TransformGaugeChartData(gaugesData) {
//     if (gaugesData == null || gaugesData.length == 0) {
//         return gaugesData;
//     }

//     var propertiesToShowGaugeFor = ['v_LLAvg', 'kvat', 'iavg', 'pft'];
//     var titleForProperties = {
//         v_LLAvg: 'Live Voltage',
//         kvat: 'Live Demand',
//         iavg: 'Live Current',
//         pft: 'Live Power Factor'
//     };

//     // Define color ranges and limits for each gauge
//     var gaugeRanges = {
//         v_LLAvg: {
//             min: 9000,
//             max: 35000,
//             colors: [
//                 [0.5, '#e8c25a'], // Yellow – 28000 to 30500
//                 [0.875, '#048f04'], // Green – 30500 to 33500
//                 [1, '#fd666d'] // Red – 33500 to 35000
//             ]
//         },
//         kvat: {
//             min: 0,
//             max: 6000,
//             colors: [
//                 [0.583, '#307ef2'], // Blue – 0 to 3500
//                 [0.75, '#e8c25a'], // Yellow – 3500 to 4500
//                 [0.833, '#048f04'], // Green – 4500 to 5000
//                 [1, '#fd666d'] // Red – 5000 to 6000
//             ]
//         },
//         iavg: {
//             min: 0,
//             max: 120,
//             colors: [
//                 [0.625, '#e8c25a'], // Yellow – 0 to 75
//                 [0.75, '#048f04'], // Green – 75 to 90
//                 [1, '#fd666d'] // Red – 90 to 120
//             ]
//         }, 
//         pft: {
//             min: 0.85,
//             max: 1.0,
//             colors: [
//                 [0.1667, '#fd666d'], // Red – 0.85 to 0.90
//                 [0.5, '#e8c25a'], // Yellow – 0.90 to 0.95
//                 [1, '#048f04'] // Green – 0.95 to 1.0
//             ]
//         }
//     };

//     var response = propertiesToShowGaugeFor.map(property => {
//         var gaugeRange = gaugeRanges[property];
//         return {
//             type: 'gauge',
//             title: titleForProperties[property],
//             detail: {
//                 formatter: gaugesData[property],
//                 valueAnimation: true,
//                 fontSize: 10,
//             },
//             data: [{
//                 value: gaugesData[property],
//                 name: property.toUpperCase()
//             }],
//             axisLine: {
//                 lineStyle: {
//                     width: 30,
//                     color: gaugeRange.colors, // Original color gradient
//                     shadowBlur: 4, // Thickness of the white border
//                     shadowColor: '#fff' // White border color
//                 },
//             },            
//             min: gaugeRange.min,
//             max: gaugeRange.max,
//             pointer: {
//                 itemStyle: {
//                     color: 'auto'
//                 }
//             },
//             axisTick: {
//                 distance: -10,
//                 length: 8,
//                 lineStyle: {
//                     color: 'rgb(16,12,42)',
//                     width: 2
//                 }
//             },
//             splitLine: {
//                 distance: -10,
//                 length: 30,
//                 lineStyle: {
//                     color: 'rgb(16,12,42)',
//                     width: 4
//                 }
//             },
//             axisLabel: {
//                 color: 'inherit',
//                 distance: 35,
//                 fontSize: 10
//             }
//         };
//     });

//     return response;
// }

export function TransformGaugeChartData(gaugesData,theme) {
    console.log(theme)
    
    if (gaugesData == null || gaugesData.length == 0) {
        return gaugesData;
    }
 
    var propertiesToShowGaugeFor = ['v_LLAvg', 'kvat', 'iavg', 'pft'];
    var titleForProperties = {
        v_LLAvg: 'Live Voltage',
        kvat: 'Live Demand',
        iavg: 'Live Current',
        pft: 'Live Power Factor'
    };

    var gaugeRanges = {
        v_LLAvg: {
            min: 9000,
            max: 35000,
            colors: [
                [0.5, '#D4AF37'],
                [0.875, '#048f04'],
                [1, '#ab0207']
            ]
        },
        kvat: {
            min: 0,
            max: 2000,
            colors: [
                [0.583, '#003366'],
                [0.75, '#D4AF37'],
                [0.833, '#048f04'],
                [1, '#ab0207']
            ]
        },
        iavg: {
            min: 0,
            max: 120,
            colors: [
                [0.625, '#D4AF37'],
                [0.75, '#048f04'],
                [1, '#ab0207']
            ]
        },
        pft: {
            min: 0.85,
            max: 1.0,
            colors: [
                [0.1667, '#ab0207'],
                [0.5, '#D4AF37'],
                [1, '#048f04']
            ]
        }
    };

    var response = propertiesToShowGaugeFor.map(property => {
        var gaugeRange = gaugeRanges[property];
        var min = gaugeRange.min;
        var max = gaugeRange.max;
        var step = (max - min) / 5; // 20% interval, so 5 steps
        var axisLabels = Array.from({ length: 6 }, (_, i) => (min + i * step).toFixed(2)); // Generate labels for 0%, 20%, 40%, 60%, 80%, 100%

        return {
            type: 'gauge',
            title: titleForProperties[property],
            detail: {
                formatter: `${gaugesData[property]}`,
                valueAnimation: true,
                fontSize: 10,
            },
            data: [{
                value: gaugesData[property],
                name: property.toUpperCase()
            }],
            axisLine: {
                lineStyle: {
                    width: 30,
                    color: gaugeRange.colors,
                    shadowBlur: 4,
                    shadowColor: '#fff'
                },
            },
            min: gaugeRange.min,
            max: gaugeRange.max,
            pointer: {
                itemStyle: {
                    color: 'auto'
                }
            },
            axisTick: {
                distance: -10,
                length: 8,
                lineStyle: {
                    color: 'rgb(16,12,42)',
                    width: 2
                }
            },
            splitLine: {
                distance: -10,
                length: 30,
                lineStyle: {
                    color: 'rgb(16,12,42)',
                    width: 4
                }
            },
            axisLabel: { 
                formatter:  function (value) {
                    let numericLabels = axisLabels.map(label => parseFloat(label)); // Convert to numeric
                    if (value === numericLabels[2]) return ''; // Hide 40%
                    if (value === numericLabels[3]) return ''; // Hide 60%
                    let midValue = ((gaugeRange.min + gaugeRange.max) / 2).toFixed(2); // Calculate 50% value
                    if (value.toFixed(2) === midValue) return midValue; 
                    if (numericLabels.includes(value)) return value.toFixed(2); // Show other values
                    return ''; // Hide all others
                },
                color: theme === 'dark' ? 'white' : 'inherit',
                distance: 35,
                fontSize: 10
            }
            
            
        };
    });

    return response;
}






export function TransformMEDataToDataTable(htData) {
    if (htData == null || htData.length == 0) {
        return [];
    }

    var response = [];

    // [
    //     {
    //       "autoID": 5,
    //       "cost": 100,
    //       "createdOn": "2024-09-21T06:30:00"
    //     }
    //   ]
    htData.map(htDataItem => {
        response.push({
            // SerialNumber: htDataItem['autoID'],
            cost: htDataItem['cost'],
            createdOn: htDataItem['createdOn'],
            action:[{ auto:htDataItem['autoID'], cost: htDataItem['cost']}],
        });
    });

    return response;
}



// export { ConvertHourlyDataForBarChart, GetCategoriesFromHourlyData, TransformGaugeChartData, TransformHTDataToDataTable, TransformVcbConsumptionToStackedBarChart, TransformWeeklyConsumptionToStackedBarChart ,TransformMEDataToDataTable};


export function TransformDataToTableData(htData) {
    if (htData == null || htData.length == 0) {
        return null;
    }
    console.log(htData)

    var response = []; 
    // {
    //     productionDataDetailsID: 1,
    //     productionDataID: 6,
    //     productionQuantity: 88966,
    //     ebUnits: 8552.5,
    //     dgUnits: 0,
    //     piecePerUnit: 10.4,
    //     totalUnits: 8552.5,
    //     productionDate: '2025-01-28T06:00:00',
    //     generatedOn: '2025-02-02T11:47:25.297'
    //   },

    htData.map(htDataItem => {
        response.push({
            'Date': htDataItem['productionDate']?.split('T')[0],
            'EB Units': htDataItem['ebUnits'],
            'DG Units': htDataItem['dgUnits'],
            'Total Units': htDataItem['totalUnits'],
            'Piece per Unit': htDataItem['piecePerUnit'],
            'Production Quantity': htDataItem['productionQuantity'],
            // status: htDataItem['v_LLAvg'] > 0 ? 'Active' : 'Inactive',
        });
    });

    return response;
}